import { useState } from "react";
import { MdLockReset } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";

const ResetPassword = () => {
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<string>("");

  const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setError("");
      setSuccess("Link sent to your Email!");
    } catch (err: any) {
      handleError(err.code);
    }
  };

  const handleError = (errorCode: string) => {
    switch (errorCode) {
      case "auth/invalid-email":
        setError("Please enter a valid email address");
        break;
      default:
        setError("An error has occured");
        break;
    }
  };

  return (
    <div className="auth">
      <form onSubmit={handleSubmit} className="auth__form">
        <h1 className="auth__form__header">Forgot Password</h1>
        <input
          type="email"
          placeholder="Enter your Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="auth__form__input"
        />
        {success && <p className="auth__form__success">{success}</p>}
        {error && <p className="auth__form__error">{error}</p>}

        <div className="auth__form__buttonGroup">
          <button type="submit" className="auth__form__button">
            <MdLockReset className="bttn-icon" />
            Reset Password
          </button>
          <p
            className="auth__form__forgotPass"
            onClick={() => navigate("/signin")}
          >
            Back to Sign In
          </p>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
